export default __webpack_public_path__ + "static/media/Chevron_Right.6bcce0c2.svg";